//#region import
import React, { useEffect, useState } from 'react';
import { Grid, Tooltip } from '@mui/material';
import { FnAxios, FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { BtnClear, BtnExportExcel, BtnSearch, BtnSendRequest } from 'components/Button/ButtonAll';
import { APIStatusCode, EnumRegisterTimelineType } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { FormProvider, useForm } from 'react-hook-form';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { BtnEditOnTable, BtnUpdateDataOnTable, BtnVersionOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import { ApiProject } from 'enum/api';
import { TextBoxItem } from 'components/Input/TextBox';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import ModalExtendPeriod from './Modal/ModalExtendPeriod';
import ModalCommittee from './Modal/ModalCommittee';
import { TaskAlt, Verified} from '@mui/icons-material';
import moment from 'moment';
//#endregion

const ProjectCheckRecordNormal = () => { //ตรวจสอบ/บันทึกผล >> ปกติ
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isPermission, setPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        arrRows: []
    });
    const [arrDataStatusID, setarrDataStatusID] = useState<any>([]);
    const [arrDataSectionTypeID, setarrDataSectionTypeID] = useState<any>([]);
    const [lstDataProjectCheckRecord, setlstDataProjectCheckRecord] = useState([]);
    const [isExportExcel, setisExportExcel] = useState(false); //ปุ่ม Export Excel File > เปิดตอนเป็น เลขา และ Admin เท่านั้น
    const [isBtnSendCommittee, setisBtnSendCommittee] = useState(false); //ปุ่ม ส่งอนุกรรมการกลั่นกรองฯ ลงคะแนน > เปิดตอนเป็น เลขา
    const [isSecretary, setisSecretary] = useState(false); //เลขา    

    //// const currentDate = new Date(); // Get the current date
    //// const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    //// const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sProjectName_Normal: null,
            arrSectionTypeID_Normal: null,
            arrStatusID_Normal: null,
            //วันที่อนุมัติโครงการ
            dStartDate_Normal: null, //_dStart,
            dEndDate_Normal: null, //_dEnd,
            //วันที่ยื่นโครงการ
            dStartDateRegister_Normal: null, //_dStart, 
            dEndDateRegister_Normal: null, //_dEnd,
        } as any,
    });

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        GetFormInitialList();
    }, []);

    const GetFormInitialList = () => {
        AxiosFn.Get(ApiProject.GetFormInitialCheckRecordNormal, {}, (result) => {
            setisExportExcel(result.isExportExcel);
            setisBtnSendCommittee(result.isBtnSendCommittee);
            setisSecretary(result.isSecretary);
            setarrDataSectionTypeID(result.lstSectionTypeID);
            form.setValue("arrSectionTypeID_Normal", result.lstSectionTypeID.map(m => m.value));
            setarrDataStatusID(result.lstStatusID);
            form.setValue("arrStatusID_Normal", result.lstStatusID.map(m => m.value));
            handleGetTableProject(dataRow);
        });
    }

    const handleGetTableProject = (p: PaginationInterface) => {
        setLoadingTable(true);
        let ObjForm = form.getValues();
        let nDate_Start = ObjForm.dStartDate_Normal ? ObjForm.dStartDate_Normal.valueOf() : null;
        let nDate_End = ObjForm.dEndDate_Normal ? ObjForm.dEndDate_Normal.valueOf() : null;
        let nDate_StartRegister = ObjForm.dStartDateRegister_Normal ? ObjForm.dStartDateRegister_Normal.valueOf() : null;
        let nDate_EndRegister = ObjForm.dEndDateRegister_Normal ? ObjForm.dEndDateRegister_Normal.valueOf() : null;
        let objParam = {
            ...p,
            sProjectName: ObjForm.sProjectName_Normal ?? null,
            lstSectionTypeID: ObjForm.arrSectionTypeID_Normal ?? [],
            lstStatusID: ObjForm.arrStatusID_Normal ?? [],
            //วันที่อนุมัติโครงการ
            nStartDate: nDate_Start,
            nEndDate: nDate_End,
            //วันที่ยื่นโครงการ
            nStartDateRegister: nDate_StartRegister,
            nEndDateRegister: nDate_EndRegister,
        };
        AxiosFn.Post(ApiProject.GetTableCheckRecordNormal, objParam, (result) => {
            setLoadingTable(false);
            if (result.nStatusCode === APIStatusCode.Success) {
                setlstDataProjectCheckRecord(result.lstDataProjectCheckRecord ?? []);
                setDataRow({
                    ...p,
                    arrRows: result.lstDataProjectCheckRecord ?? [],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    };

    const goToEdit = (sID: string, sMode: string) => {
        let sUrl = "/ProjectCheckRecordFrom";
        navigate(sUrl, { state: { sID: sID, sMode: sMode, sRegisterTimelineType: EnumRegisterTimelineType.Normal, sModeSecretary: (sMode === "Update" ? false : isSecretary), sPathNameBack: "/ProjectCheckRecordList" } });
    };

    const dataColumn: any = [
        {
            field: "isBtnEdit",
            headerName: `${I18n.SetText("Project.sManagement")}`,
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            disableReorder: true,
            width: 80,
            getActions: (item) => {
                return [
                    <>
                        {isPermission ? 
                            <>
                                {item.row.isBtnUpdate &&
                                    <BtnUpdateDataOnTable
                                        key={item.row.sID}
                                        id="btnUpdate"
                                        txt={"ลงคะแนน"}
                                        icon={<TaskAlt />}
                                        onClick={() => goToEdit(item.row.nProjectID, "Update")}
                                        IsDisabled={!isPermission}
                                    />
                                }
                                {item.row.isBtnEdit ?
                                    <BtnEditOnTable
                                        key={item.row.sID}
                                        id="btnEdit"
                                        onClick={() => goToEdit(item.row.nProjectID, "Edit")}
                                        IsDisabled={!isPermission}
                                    />
                                    :
                                    <BtnViewDataOnTable
                                        key={item.row.sID}
                                        id="btnView"
                                        onClick={() => goToEdit(item.row.nProjectID, "View")}
                                    // IsDisabled={isPermission}
                                    />
                                }
                            </>
                        : 
                            <BtnViewDataOnTable
                                key={item.row.sID}
                                id="btnView"
                                onClick={() => goToEdit(item.row.nProjectID, "View")}
                                // IsDisabled={isPermission}
                            />                        
                        }
                    </>
                ];
            },
        },
        {
            field: "sStatusTableName", //field: "sStatusName",
            headerName: `${I18n.SetText("Project.sStatus")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 3,
            //// renderCell: (item) => {
            ////     return (item.row.nProgressStatusID ? item.row.sProgressStatus : item.row.sStatusName);
            //// }
            renderCell: (item) => {
                return (
                    <Grid item container spacing={1} xs={12} md={12} justifyContent={'space-between'} alignItems={'center'}>
                        <Grid item >
                            <span>{item.row.sStatusTableName}</span>
                        </Grid>
                        {(item.row.isBtnUpdate && item.row.isScoreComplete) &&
                            <Grid item>
                                <Tooltip title={'ลงคะแนนเรียบร้อยแล้ว'} >
                                    <Verified
                                        sx={{
                                            color: "#46b838 !important",
                                            fontSize: '2.1rem',
                                            "&:hover": { color: "#318727 !important", },
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                        }
                    </Grid>
                );
            },
        },
        {
            field: "sProjectName",
            headerName: `${I18n.SetText("Project.sProjectName")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            disableReorder: true,
            flex: 5,
            renderCell: (item) => {
                return (
                    <Grid item container spacing={1} xs={12} md={12} justifyContent={'space-between'}>
                        <Grid item >
                            <span>{item.row.sProjectName}</span>
                        </Grid>
                        {(item.row.lstExtendPeriod || []).length > 0 &&
                            <Grid item>
                                {/* <Tooltip title={'ประวัติการดำเนินการขยายระยะเวลา'} >
                                    <DashboardCustomize
                                        sx={{
                                            color: "#930012 !important",
                                            "&:hover": {
                                                color: "#063b9f !important",
                                            },
                                            cursor: "pointer",
                                        }}
                                        // titleAccess='ประวัติการดำเนินการขยายระยะเวลา'
                                        onClick={() => onOpenModalExtendPeriod(item.row.lstExtendPeriod)}
                                    />
                                </Tooltip> */}
                                <BtnVersionOnTable id={"BtnVersion"} txt={'ประวัติการดำเนินการขยายระยะเวลา'} IsCircleWithOutText={true} onClick={() => onOpenModalExtendPeriod(item.row.lstExtendPeriod)} />
                            </Grid>
                        }
                    </Grid>
                );
            },
        },
        {
            field: "sProjectOwner",
            headerName: `${I18n.SetText("Project.sProjectOwner")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            disableReorder: true,
            flex: 3,
        },
        {
            field: "nProjectYear",
            headerName: `${I18n.SetText("Project.sProjectYear")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            // flex: 1,
            width: 60,
        },
        {
            field: "sSectionType",
            headerName: `${I18n.SetText("Project.sProjectType")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
        {
            field: "nBudgetPlan",
            headerName: `${I18n.SetText("Project.sBudgetPlan")}`,
            headerAlign: "center",
            align: "right",
            sortable: true,
            disableReorder: true,
            flex: 2,
            renderCell: (item) => {
                return (formatNumber(item.row.nBudgetPlan, 2));
            },
        },
        {
            field: "nBudgetReallySpend",
            headerName: `${I18n.SetText("Project.sBudgetReallySpend")}`,
            headerAlign: "center",
            align: "right",
            sortable: true,
            disableReorder: true,
            flex: 2,
            renderCell: (item) => {
                return (formatNumber(item.row.nBudgetReallySpend, 2));
            },
        },
        {
            field: "sRegisterDate",
            headerName: `${I18n.SetText("Project.sDateRegister")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
        {
            field: "sApproveDate",
            headerName: `${I18n.SetText("Project.sDateApprover")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
    ];

    const [isOpenExtendPeriod, setisOpenExtendPeriod] = useState(false); //Pop Up > ประวัติการดำเนินการขยายระยะเวลา และปรับแผนโครงการ
    const [lstExtendPeriod, setlstExtendPeriod] = useState([]);
    const onOpenModalExtendPeriod = (_lstExtendPeriod) => {
        setisOpenExtendPeriod(true);
        setlstExtendPeriod(_lstExtendPeriod);
    };

    const [isOpenCommittee, setisOpenCommittee] = useState(false); //Pop Up > ส่งอนุกรรมการกลั่นกรองฯ ลงคะแนน > เปิดตอนเป็น เลขา
    const [ObjDataCommittee, setObjDataCommittee] = useState(null);
    const onOpenModalCommittee = () => {
        setisOpenCommittee(true);

        AxiosFn.Get(ApiProject.GetFormCommitteeNormal, {}, (result) => {
            let ObjDataCommittee = {
                nYear: result.nYear, //คณะอนุกรรมการประจำปี
                lstProject: result.lstProject, //Project Status 5 เท่านั้น
                lstCommitteeRoundID: result.lstCommitteeRoundID, //รอบที่เปิดในปีนั้นๆ
                lstCommitteeRoundUser: result.lstCommitteeRoundUser, //ข้อมูลในแต่ล่ะ รอบที่เปิดในปีนั้นๆ
            };
            setObjDataCommittee(ObjDataCommittee);
        });
    };

    const onExportExcel = () => { //Export Excel Fil > เปิดตอนเป็น เลขา และ Admin        
        DialogFn.BlockUI();
        let nYearThai = parseInt(moment().format('YYYY')) + 543;
        let sFileName = `ข้อมูลโครงการ_ปกติ_${moment().format('DMMM')}${nYearThai}.xlsx`;

        let ObjForm = form.getValues();
        let nDate_Start = ObjForm.dStartDate_Normal ? ObjForm.dStartDate_Normal.valueOf() : null;
        let nDate_End = ObjForm.dEndDate_Normal ? ObjForm.dEndDate_Normal.valueOf() : null;
        let nDate_StartRegister = ObjForm.dStartDateRegister_Normal ? ObjForm.dStartDateRegister_Normal.valueOf() : null;
        let nDate_EndRegister = ObjForm.dEndDateRegister_Normal ? ObjForm.dEndDateRegister_Normal.valueOf() : null;

        let param = {
            isFastTrack: false,
            sProjectName: ObjForm.sProjectName_Normal ?? null,
            lstSectionTypeID: ObjForm.arrSectionTypeID_Normal ?? [],
            lstStatusID: ObjForm.arrStatusID_Normal ?? [],
            //วันที่อนุมัติโครงการ
            nStartDate: nDate_Start,
            nEndDate: nDate_End,
            //วันที่ยื่นโครงการ
            nStartDateRegister: nDate_StartRegister,
            nEndDateRegister: nDate_EndRegister,
        }
        AxiosFn.DowloadFileBlob(ApiProject.ExportProjectExcelList, param, sFileName, () => {
            DialogFn.UnBlockUI();
        });
    }

    return (
        <Grid item container spacing={2} xs={12} md={12} style={{ padding: '1%', }} >
            <FormProvider {...form}>
                <Grid item container spacing={2} xs={12} md={12} justifyContent={'flex-start'} justifyItems={'flex-start'} alignItems={'center'}>
                    {isExportExcel &&
                        <Grid item>
                            <BtnExportExcel id={'btnExportExcel_Normal'} onClick={() => { onExportExcel(); }} /> {/* txt={'Export Excel File'}  */}
                        </Grid>
                    }
                    {isBtnSendCommittee &&
                        <Grid item>
                            <BtnSendRequest id={'btnSend_Normal'} txt={'ส่งอนุกรรมการกลั่นกรองฯ ลงคะแนน'} bgcolorHover={'#00b2b3'} bgcolor={'#14aaab'} onClick={() => { onOpenModalCommittee(); }} />
                        </Grid>
                    }
                </Grid>
                <Grid item container spacing={2} xs={12} md={12} justifyItems={'end'} justifyContent={'end'} alignItems={'center'}>
                    <Grid item xs={12} md={4}>
                        <TextBoxItem
                            id={"sProjectName_Normal"}
                            name={"sProjectName_Normal"}
                            label={`${I18n.SetText("Project.sProjectName")}`}
                            required={false}
                            maxLength={250}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <MultipleSelectItem
                            id={"arrSectionTypeID_Normal"}
                            name={"arrSectionTypeID_Normal"}
                            label={`${I18n.SetText("Project.sProjectType")}`}
                            required={false}
                            options={arrDataSectionTypeID}
                            disabled={false}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <MultipleSelectItem
                            id={"arrStatusID_Normal"}
                            name={"arrStatusID_Normal"}
                            label={`${I18n.SetText("Project.sStatus")}`}
                            required={false}
                            options={arrDataStatusID}
                            disabled={false}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={5} container spacing={1}>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dStartDateRegister_Normal"}
                                id={"dStartDateRegister_Normal"}
                                label={`${I18n.SetText("Project.sStartDateRegister")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                maxDate={form.watch("dEndDateRegister_Normal")}
                            />
                        </Grid>
                        <Grid item style={{ marginTop: '2%' }}> - </Grid>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dEndDateRegister_Normal"}
                                id={"dEndDateRegister_Normal"}
                                label={`${I18n.SetText("Project.sEndDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                minDate={form.watch("dStartDateRegister_Normal")}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={5} container spacing={1}>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dStartDate_Normal"}
                                id={"dStartDate_Normal"}
                                label={`${I18n.SetText("Project.sStartDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                maxDate={form.watch("dEndDate_Normal")}
                            />
                        </Grid>
                        <Grid item style={{ marginTop: '2%' }}> - </Grid>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dEndDate_Normal"}
                                id={"dEndDate_Normal"}
                                label={`${I18n.SetText("Project.sEndDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                minDate={form.watch("dStartDate_Normal")}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={1.2} container spacing={1} justifyItems={'end'} justifyContent={'flex-start'}>
                        <Grid item>
                            <BtnClear
                                id={'btnClearSearchAll_Normal'}
                                IsCircleWithOutText={true}
                                onClick={() => {
                                    form.reset();
                                    form.setValue("arrSectionTypeID_Normal", arrDataSectionTypeID.map(m => m.value));
                                    form.setValue("arrStatusID_Normal", arrDataStatusID.map(m => m.value));
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <BtnSearch id={'btnSearchAll_Normal'} IsCircleWithOutText={true} onClick={() => { handleGetTableProject(dataRow); }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <DataGrid
                        sTableID='TB_Project_Normal'
                        isLoading={loadingTable}
                        columns={dataColumn}
                        rows={dataRow}
                        onLoadData={handleGetTableProject}
                        isHiddenToolHead={true}
                        isShowCheckBox={false}
                    />
                </Grid>
            </FormProvider>

            <ModalExtendPeriod isOpen={isOpenExtendPeriod} setIsOpen={setisOpenExtendPeriod} lstDataAll={lstExtendPeriod} />
            <ModalCommittee isOpen={isOpenCommittee} setIsOpen={setisOpenCommittee} ObjData={ObjDataCommittee} onSubmit={(e) => { handleGetTableProject(initRows) }} />
        </Grid>
    )
}
export default ProjectCheckRecordNormal;
